import React from "react";
import "./PageWrapper.css"; // You can define common styles here
import Colors from '../styles/Colors.json'; // Assuming you want to keep the Colors.json styling
import BackArrow from "./BackArrow";
import WeekSelector from "./WeekSelector";

interface PageWrapperProps {
  title: string;
  children: React.ReactNode;
  backgroundColor: string;
  backArrow?: boolean;
  noDataMessage?: string;
  weekSelector?: boolean;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  title,
  children,
  backArrow = false,
  backgroundColor,
  weekSelector = false
}) => {
  return (
    <div className="page-wrapper">
      <h3>{backArrow && <BackArrow />} {title}</h3>
      <hr />
      {weekSelector && <WeekSelector />}
      <div className="content" style={{ backgroundColor: backgroundColor, marginTop: 5 }}>
        <div style={{ backgroundColor: backgroundColor }}>
            {children}
        </div>
      </div>
    </div>
  );
};

export default PageWrapper;